"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTypes = void 0;
var EmailTypes;
(function (EmailTypes) {
    // feedbacks
    EmailTypes["customerFeedbackRequest"] = "customerFeedbackRequest";
    EmailTypes["feedbackCollection"] = "feedback-collection";
    // agents
    EmailTypes["commissionSettlement"] = "commissionSettlement";
    EmailTypes["newBusinessConditions"] = "newBusinessConditions";
    EmailTypes["reservedOrderSaved"] = "reservedOrderSaved";
    EmailTypes["reservedOrderReminder"] = "reservedOrderReminder";
    EmailTypes["reservedOrderCancelled"] = "reservedOrderCancelled";
    EmailTypes["travelAgentApproval"] = "travelAgentApproval";
    EmailTypes["travelAgentAutoApproval"] = "travelAgentAutoApproval";
    EmailTypes["travelAgentFeedbackRequest"] = "travelAgentFeedbackRequest";
    EmailTypes["travelAgentRegistration"] = "travelAgentRegistration";
    EmailTypes["travelAgentResetPassword"] = "travelAgentResetPassword";
    // bookings
    EmailTypes["ordersReminder"] = "ordersReminder";
    EmailTypes["driverChanged"] = "driverChanged";
    EmailTypes["orderConfirmation"] = "orderConfirmation";
    EmailTypes["vehicleChanged"] = "vehicleChanged";
    EmailTypes["orderAccepted"] = "orderAccepted";
    EmailTypes["orderCancellation"] = "orderCancellation";
    EmailTypes["orderDeclined"] = "orderDeclined";
    EmailTypes["orderPickupAddressAirport"] = "orderPickupAddressAirport";
    EmailTypes["poolOrderConfirmed"] = "poolOrderConfirmed";
    EmailTypes["unpaidPreauthorizedPaymentOrder"] = "unpaidPreauthorizedPaymentOrder";
    EmailTypes["higherCategoryCarNotification"] = "higherCategoryCarNotification";
    EmailTypes["orderPickupAddressPort"] = "orderPickupAddressPort";
    EmailTypes["orderPickupAddressMissing"] = "orderPickupAddressMissing";
    EmailTypes["orderPickupAddressTrain"] = "orderPickupAddressTrain";
    EmailTypes["orderPickupAddressMeetingPosition"] = "orderPickupAddressMeetingPosition";
    EmailTypes["orderChanges"] = "orderChanges";
    EmailTypes["orderChangeRequestCSNotification"] = "orderChangeRequestCSNotification";
    EmailTypes["orderChangeRequestCustomerNotification"] = "orderChangeRequestCustomerNotification";
    EmailTypes["tripTrackingEmail"] = "tripTrackingEmail";
    EmailTypes["orderOwnChildSeat"] = "orderOwnChildSeat";
    EmailTypes["customTripNotAvailable"] = "customTripNotAvailable";
    EmailTypes["missingAddressesReminder"] = "missingAddressesReminder";
    // customers
    EmailTypes["userRegistrationVerification"] = "userRegistrationVerification";
    EmailTypes["customerVerification"] = "customerVerification";
    EmailTypes["abandonedCart"] = "abandonedCart";
    EmailTypes["poolAbandonedCart"] = "poolAbandonedCart";
    EmailTypes["returnTripUpsellEmail"] = "returnTripUpsellEmail";
    EmailTypes["referralInitial"] = "referralInitial";
    EmailTypes["referralNotification"] = "referralNotification";
    EmailTypes["referralReferee"] = "referralReferee";
    EmailTypes["failedPreauthorizedPayment"] = "failedPreauthorizedPayment";
    // drivers
    EmailTypes["vehicleInsuranceExpirationReminder"] = "vehicleInsuranceExpirationReminder";
    EmailTypes["firstRideFeedbackRequest"] = "firstRideFeedbackRequest";
    EmailTypes["sendUpcomingTripsRemindersForDriverEmails"] = "sendUpcomingTripsRemindersForDriverEmails";
    EmailTypes["sendUpcomingTripChangeForDriver"] = "sendUpcomingTripChangeForDriver";
    EmailTypes["sendAssignationsAcceptedEmails"] = "sendAssignationsAcceptedEmails";
    EmailTypes["sendAssignationsCancelledEmails"] = "sendAssignationsCancelledEmails";
    EmailTypes["sendAssignationsDeclinedAutomaticallyEmails"] = "sendAssignationsDeclinedAutomaticallyEmails";
    EmailTypes["sendAssignationsDeclinedByDriverEmails"] = "sendAssignationsDeclinedByDriverEmails";
    EmailTypes["sendAssignationsPendingEmails"] = "sendAssignationsPendingEmails";
    EmailTypes["signedCooperationAgreementDynamicForm"] = "signedCooperationAgreementDynamicForm";
    EmailTypes["stripeAccountOnboardingLinkEmail"] = "stripeAccountOnboardingLinkEmail";
    EmailTypes["documentDeclined"] = "documentDeclined";
    EmailTypes["vehicleDocumentDeclined"] = "vehicleDocumentDeclined";
    EmailTypes["profilePhotoDeclined"] = "profilePhotoDeclined";
    EmailTypes["driverDeactivated"] = "driverDeactivated";
    EmailTypes["firstRideAfterThreeMonths"] = "firstRideAfterThreeMonths";
    EmailTypes["rideCancelled"] = "rideCancelled";
    EmailTypes["activateYourStripeWallet"] = "activateYourStripeWallet";
    EmailTypes["payoutFailedDueToInactiveStripeWallet"] = "payoutFailedDueToInactiveStripeWallet";
    EmailTypes["personalComboAssignationOffer"] = "personalComboAssignationOffer";
    // management notifications
    EmailTypes["paymentUnsuccessful"] = "paymentUnsuccessful";
    EmailTypes["cautionDoubleBookingsNotification"] = "cautionDoubleBookingsNotification";
    EmailTypes["urgentDoubleBookingsNotification"] = "urgentDoubleBookingsNotification";
    EmailTypes["ordersCustomNotification"] = "ordersCustomNotification";
    EmailTypes["orderMessageToManager"] = "orderMessageToManager";
    EmailTypes["confirmationEmailFailed"] = "confirmationEmailFailed";
    EmailTypes["unconfirmedOrderWithAcceptedAssignationNotification"] = "unconfirmedOrderWithAcceptedAssignationNotification";
    // users
    EmailTypes["passwordReset"] = "passwordReset";
    EmailTypes["passwordResetInstructions"] = "passwordResetInstructions";
    EmailTypes["magicLinkVerification"] = "magicLinkVerification";
    // campaigns
    EmailTypes["visa50KCampaignDiscountCode"] = "visa50KCampaignDiscountCode";
    EmailTypes["discountCodeGeneric"] = "discountCodeGeneric";
})(EmailTypes || (exports.EmailTypes = EmailTypes = {}));
//# sourceMappingURL=EmailTypes.js.map